import type { Map } from 'leaflet';
import { useEffect } from 'react';
import { useMap, useMapEvents } from 'react-leaflet';

import { useActions } from '@/overmind';

const getMapCenterPayload = (map: Map) => {
  return { zoom: map.getZoom(), center: map.getCenter(), bounds: map.getBounds() };
};

export function SaveMapPosition() {
  const { setMapCenter } = useActions().map;
  const map = useMap()
  useMapEvents({
    moveend: () => {
      setMapCenter(getMapCenterPayload(map));
    },
    zoomend: () => {
      setMapCenter(getMapCenterPayload(map));
    }
  })
  
  useEffect(() => {
    if (map) {
      setMapCenter(getMapCenterPayload(map));
    }
  }, [map, setMapCenter]);
  return null;
}
